module.exports = __webpack_public_path__ + "static/img/victim-teens-4.efbfe4df.png";